// client/src/api/api.js
import axios from 'axios';
import { readAuthToken } from '../utils/authToken';

const API_URL = '/api';

// Créer une instance axios avec la configuration de base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});


// Log pour le debug
api.interceptors.request.use(
  (config) => {
    // Identifier le joueur auprès du serveur (JWT) — indispensable pour le
    // PvP : le serveur associe chaque requête à un côté du plateau.
    const token = readAuthToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`[API] Requête ${config.method.toUpperCase()} vers ${config.url}`, config.data || '');
    return config;
  },
  (error) => {
    console.error('[API] Erreur de requête:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    console.log(`[API] Réponse de ${response.config.url}:`, response.status);
    return response;
  },
  (error) => {
    console.error('[API] Erreur de réponse:', error.response || error);
    return Promise.reject(error);
  }
);


export default api;